import React, { useState } from 'react';
import Layout from "./components/layout";
import './style/style.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Joyride, { ACTIONS, EVENTS, ORIGIN, STATUS, CallBackProps } from 'react-joyride';
import { useAppContextProvider } from './contextapi';

const StepsDesc = [
    {
        content: <div className='first-slide'><h2>Welcome to iAuthor LaTeX - Online proofing tool</h2>
            <p>Please take a quick tour to help familiarize  yourself with tool.</p></div>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        placement: 'center',
        target: 'body',
    },
    {
        content: <p>Compile the PDF once and then proceed to make corrections. After making edits, click the compile button to generate the PDF that reflects all changes. The PDF will appear next to the editor for easy reference.</p>,
        placement: 'bottom',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.firststep',
        title: 'Compile',
    },
    {
        content: <p>Use this functionality if you want to communicate information to the typesetter, or to instruct changes you are unable to make.</p>,
        placement: 'left',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.secondstep',
        title: 'Comment',
    },
    {
        content: <p>Please review all the AQs, you must either reply or accept each before the article can be submitted.</p>,
        placement: 'left',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.thirdstep',
        title: 'Author Query',
    },
    {
        content: <p>To save a version of the current document, use <i>Download PDF</i>. The PDF will have the track changes that allows you to share, review, or archive a copy.</p>,
        placement: 'left',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.fourthstep',
        title: 'Download PDF',
    },
    {
        content: <p>The modifications you make to the article in iAuthor can be viewed in the track changes panel. The panel also offers the opportunity to reject your changes. You can use the dropdown to filter the changes made by the respective user.</p>,
        placement: 'left',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.fifthstep',
        title: 'Track Changes',
    },
    {
        content: <p>Click on the attachment icon to upload files for replacement images or supplementary files in any format.</p>,
        placement: 'right',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.sixthstep',
        title: 'Attachment',
    },
    {
        content: <p>Access any files provided along with the manuscript files through <i>Supplementary</i>    Files to review or download as needed.</p>,
        placement: 'right',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.seventhstep',
        title: 'Supplementary files',
    },
    {
        content: <p>You can view high-resolution images here, which will be used in the final print publication. Alt text has been generated for the images. Ensure each description is verified before final submission.
            <br></br><br></br>
            <strong>Please Note:</strong> Alt text cannot be edited here. Please update it in the LaTeX source, and the changes will be reflected here.</p>,
        placement: 'right',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.eigthstep',
        title: 'Images',
    },
    {
        content: <p>Version history - Use Version History to access previous versions of the document, which allows to view and download for reference.</p>,
        placement: 'right',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.ninthstep',
        title: 'Version history',
    },
    {
        content: <p> Once you have made all required changes, verified the alt text for images, and answered all author queries, please select "Submit" to allow your article to move to the next stage of the process.
            Please Note: You will be unable to make further changes to the article once it is submitted.</p>,
        placement: 'left',
        styles: {
            options: {
                width: 400,
            },
        },
        target: '.tenthstep',
        title: 'Submit',
    }
];

function Home() {
    const [run, setRun] = useState(false);
    const [steps] = useState(StepsDesc);
    const [stepIndex, setStepIndex] = useState(0);
    const { mainView, userProfile, fullData } = useAppContextProvider();
    const liveRegionRef = React.useRef(null);
    const [liveRegionText, setLiveRegionText] = useState("");

    const handleJoyrideCallback = (data) => {
        const { action, index, origin, status, type } = data;

        // When tour is closed, skipped, or finished
        if (action === 'close' || [STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            setRun(false);
            setStepIndex(0); // Reset stepIndex so tour can be started again immediately
            // Announce username and filename in hidden live region for screen readers
            setLiveRegionText(`${fullData?.Filename || ''} ${userProfile?.username || ''}`);
            setTimeout(() => {
                if (liveRegionRef.current) {
                    liveRegionRef.current.focus();
                }
            }, 100);

            // A11y (#1 — WCAG 2.4.3 Focus Order): do NOT manually move focus when the
            // tour closes. Focus returns to the top of the page (document body), so keyboard
            // users Tab from the top and mouse users see nothing appear. (Previously focus
            // was pushed into the editor; focusing the skip link made it flash for mouse
            // users when they clicked Skip.)
        }

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
        }

        console.groupCollapsed(type);
        console.log(data); //eslint-disable-line no-console
        console.groupEnd();
    };
    
    
    const StartTour = (val) => {
        setRun(val);
    };

    const handleHelp = () => {
        setRun(true);
        setStepIndex(0);
    }

    return (
        <>
    {/* Visually hidden live region for screen reader announcements. This is included because the tester wants to announce the Filename and Username. */}
        <div
        aria-live="polite"
        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}
        >
        {liveRegionText}
        </div>

            <Joyride
                steps={steps}
                run={run}
                continuous={true}
                scrollToFirstStep={false}
                showProgress={true}
                showSkipButton={true}
                callback={handleJoyrideCallback}
                stepIndex={stepIndex}
                locale={{
                    skip: "Skip",
                    last: "Close",
                }}
                disableCloseOnEsc={true}
                disableOverlayClose={true}
                // styles={{
                // options: {
                //     zIndex: 10000,
                // },
                // buttonClose: {
                //     display: "none", // completely hides the close button
                // },
                // }}
            />
            <Layout StartTour={StartTour} handleHelp={handleHelp} />
            <ToastContainer />
        </>
    )
}

export default Home;
